import React from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as SuccessIcon } from "../../../../media/icons/successIcon.svg";
import { Modal } from "../../../common/modal";

import styles from "./questionFormSuccess.module.css";

const QuestionFormSuccess = ({ clearAllModals }) => {
  const { t } = useTranslation();

  const handleClose = () => {
    clearAllModals();
  };

  return (
    <Modal
      closeModal={clearAllModals}
      clearAllModals={clearAllModals}
      classNameMain={styles.modal}
      classNameButton={styles.closeIcon}
      isDisableCloseOutside
    >
      <section className={styles.content}>
        <SuccessIcon className={styles.icon} />
        <h3 className={styles.title}>{t("dashboard_newaccount_popup_step1_confirm_title")}</h3>
        <p className={styles.text}>{t("dashboard_newaccount_popup_step1_confirm_desc")}</p>
        <div className={styles.actions}>
          <button type="button" className={styles.primaryButton} onClick={handleClose}>
            {t("dashboard_common_close")}
          </button>
          <a href="https://help.heritageweb.com/" target="_blank" rel="noopener noreferrer" className={styles.secondaryButton}>
            {t("dashboard_newaccount_popup_step1_confirm_help_button")}
          </a>
        </div>
      </section>
    </Modal>
  );
};

export default QuestionFormSuccess;
